import React from 'react'
import styles from './styles.css'
import moment from 'moment'
import useKeyboardEvent from 'App/hooks/useKeyboardEvent'
import useState from 'App/hooks/useState'

export default function ConversationLogs(props) {
  const {conversation} = props
  const [show, setShow] = useState(false)

  useKeyboardEvent('control+shift+h', () => {
    setShow(show => !show)
  })

  if (!conversation) return null

  const {logs} = conversation
  if (!logs || !show) return null

  return (
    <div className={styles.container}>
      <div className={styles.title}>Logs</div>
      {logs.map((log, index) => (
        <div className={styles.log} key={log.date}>
          <div>{log.text}</div>
          <div className={styles.details}>
            <span>Por</span>
            <span className={styles.user}>{log.senderName}</span>
            <span className={styles.date}>el {moment(log.date).format('DD MMM - HH:mm')}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
